import { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useCompactPortrait, useNavigationAction } from 'components/navigation/NavigationContext';

export default function AgendaToolbar({
  toggleText,
  toggleColor,
  isNoSleep,
  toggleWakeOnScreen,
  editMode,
  setEditMode,
  getMeeting,
  isLocked = false,
  isAssignedJudge = false,
  onOpenJudgePanel = null,
  isAssignedTiebreaker = false,
  onOpenTiebreakerPanel = null,
  isAssignedChiefJudge = false,
  onOpenChiefJudgePanel = null,
  onOpenTableTopicsResults = null
}) {
  const { user: authUser } = useSelector((state) => state.auth);
  const compact = useCompactPortrait();
  const [open, setOpen] = useState(false);
  useNavigationAction('tools', {
    label: 'Agenda Tools',
    icon: 'bi-tools',
    renderContent: ({ closeMore }) => (
      <div className="mobile-more-actions" onClick={event => {
        if (event.target.closest('button:not(:disabled)') && !event.target.closest('[data-mobile-modal]')) closeMore();
      }}>
        {renderTools()}
      </div>
    ),
  });
  const toggleRef = useRef(null);
  const modalRef  = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onPointerDown(e) {
      if (modalRef.current  && modalRef.current.contains(e.target))  return;
      if (toggleRef.current && toggleRef.current.contains(e.target)) return;
      setOpen(false);
    }
    function onKeyDown(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const isOfficer = authUser?.user?.acl?.toLowerCase() === 'officer';

  const renderTools = () => (
    <>
            {isAssignedChiefJudge && typeof onOpenChiefJudgePanel === 'function' && (
              <button className="agenda-modal-item active" onClick={() => { onOpenChiefJudgePanel(); setOpen(false); }}>
                <i className="bi bi-clipboard-data"></i>
                <span>Chief Judge Panel</span>
              </button>
            )}
            {isAssignedJudge && typeof onOpenJudgePanel === 'function' && (
              <button
                className="agenda-modal-item active"
                onClick={() => {
                  onOpenJudgePanel();
                  setOpen(false);
                }}
              >
                <i className="bi bi-trophy"></i>
                <span>Judging Panel</span>
              </button>
            )}

            {isAssignedTiebreaker && typeof onOpenTiebreakerPanel === 'function' && (
              <button
                className="agenda-modal-item active"
                onClick={() => {
                  onOpenTiebreakerPanel();
                  setOpen(false);
                }}
              >
                <i className="bi bi-list-ol"></i>
                <span>Tiebreaker Panel</span>
              </button>
            )}

            {typeof onOpenTableTopicsResults === 'function' && (
              <button
                className="agenda-modal-item"
                data-mobile-modal
                onClick={() => { onOpenTableTopicsResults(); setOpen(false); }}
              >
                <i className="bi bi-chat-quote"></i>
                <span>Table Topics Results</span>
              </button>
            )}

            <button
              className="agenda-modal-item"
              onClick={() => { toggleWakeOnScreen(); setOpen(false); }}
            >
              <i className={`bi ${isNoSleep ? 'bi-moon' : 'bi-display'}`}></i>
              <span>{toggleText}</span>
            </button>

            <button
              className="agenda-modal-item"
              onClick={() => {
                toast.info('Agenda reloaded!', { position: 'bottom-left' });
                getMeeting();
                setOpen(false);
              }}
            >
              <i className="bi bi-arrow-clockwise"></i>
              <span>Reload Agenda</span>
            </button>

            {isOfficer && (
              <button
                className={`agenda-modal-item${editMode ? ' active' : ''}`}
                disabled={isLocked}
                title={isLocked ? 'This meeting is locked' : undefined}
                onClick={() => { if (isLocked) return; setEditMode(v => !v); setOpen(false); }}
              >
                <i className={`bi ${isLocked ? 'bi-lock-fill' : 'bi-pencil-square'}`}></i>
                <span>{isLocked ? 'Meeting Locked' : editMode ? 'Disable Editing' : 'Enable Editing'}</span>
              </button>
            )}
    </>
  );

  return (
    <>
      <div ref={toggleRef} className="agenda-toolbar-fixed">
        <button
          className="agenda-toolbar-toggle"
          onClick={() => setOpen(v => !v)}
          aria-label="Toggle agenda tools"
        >
          <i className="bi bi-tools" />
        </button>
      </div>
      {!compact && open && (
        <>
          <div className="agenda-modal-overlay" onClick={() => setOpen(false)} />
          <div ref={modalRef} className="agenda-modal-popup">{renderTools()}</div>
        </>
      )}
    </>
  );
}
